var app = angular.module('leonardo');

var AccountUserRole = function (AuthDataService) {
  return function (account_user_role) {
    var label = 'Not specified yet';
    if (!isNull(account_user_role)) {
      angular.forEach(AuthDataService.authData.account_user_roles, function(role) {
        if (account_user_role == role.id) {
          label = role.name;
        }
      });
    }
    return label;
  };
};

app.filter('accountUserRole', ['AuthDataService', AccountUserRole]);
